import * as React from 'react'
import {Box} from "@chakra-ui/react";
import {domToReact} from "html-react-parser";
import {useEffect} from "react";

export default function CustomerLifetimeValueCalculator({children, post}){
    const html = domToReact(children) ?? null
    const inputIds = ['totalTransactions', 'averageOrderValue', 'averageLifetime'];

    useEffect(() => {
        const handleInputChange = () => {
            const values = inputIds.map(id => {
                const input = document.getElementById(id);
                return parseFloat(input.value) || input.getAttribute('step');
            });
            const product = values.reduce((acc, value) => acc * value, 1);
            document.getElementById('clvResult').textContent = product.toFixed(2);
        };

        inputIds.forEach(id => {
            const input = document.getElementById(id);
            input.addEventListener('input', handleInputChange);
        });

        handleInputChange();
    }, []);

    return (
        <Box className={'clv'} fontSize={'18px'} fontWeight={'normal'} lineHeight={'30px'}
            sx={{
                '& input[type="number"]:focus-visible' : {
                    border:'none',
                    borderBottom:'1px solid #28aae2 !important',
                    outline:'none !important',
                    boxShadow:'none !important'
                },
                    '& input[type="number"]:focus::-webkit-input-placeholder' : {
                        color: 'transparent'
                    }
            }}>
            <Box as={'h3'} mb={'10px'}>{html}</Box>
            <Box>
                <label htmlFor="totalTransactions">Całkowita liczba transakcji (T):</label>
                <Box as={'input'} type="number" id="totalTransactions" step="1" placeholder={'1'} borderBottom={'1px solid #DBE1EA'} ml={'20px'}/>
            </Box>
            <Box>
                <label htmlFor="averageOrderValue">Średnia wartość zamówienia (AOV):</label>
                <Box as={'input'} type="number" id="averageOrderValue" step="0.01" placeholder={'0.01'} borderBottom={'1px solid #DBE1EA'} ml={'20px'}/>
            </Box>
            <Box>
                <label htmlFor="averageLifetime">Średnia długość życia klienta (w miesiącach) (ALT):</label>
                <Box as={'input'} type="number" id="averageLifetime" step="1" placeholder={'1'} borderBottom={'1px solid #DBE1EA'} ml={'20px'}/>
            </Box>
            <p>Liczba klientów w danym okresie: <Box as={'span'} id={'clvResult'} fontWeight={'bold'}></Box></p>
        </Box>
    )
}